import { GetServerSidePropsContext, InferGetServerSidePropsType } from "next";
import Layout from "../../../../components/org/Layout";
import { Container, Link, Typography } from "@mui/material";
import * as React from "react";
import { useTranslation } from "../../../../utils/i18n/lang";
import { messages } from "../../../../utils/i18n/i18n";
import { seriesDetailRoute, seriesListRoute } from "../../../../routes/org";
import { constNull, pipe } from "fp-ts/function";
import { either, nonEmptyArray, option, task, taskEither } from "fp-ts";
import { QueryError } from "../../../../utils/supabase/QueryState";
import { errorsToMessage, runTask } from "../../../../utils/fp";
import { publishedSeriesListQuery } from "../../../../hooks/series";
import { InternalLink } from "../../../../components/common/Link";

type SsrError =
    | { type: "query"; reason: string }
    | {
          type: "fetch";
          reason: QueryError;
      };

export const getServerSideProps = async (
    context: GetServerSidePropsContext
) => {
    return pipe(
        context.query,
        seriesListRoute.queryCodec.decode,
        either.mapLeft(
            (e): SsrError => ({ type: "query", reason: errorsToMessage(e) })
        ),
        taskEither.fromEither,
        taskEither.chain((query) =>
            pipe(
                publishedSeriesListQuery(query.subdomain),
                taskEither.mapLeft(
                    (e): SsrError => ({
                        type: "fetch",
                        reason: e,
                    })
                ),
                taskEither.map((seriesList) => ({
                    seriesList,
                    query,
                }))
            )
        ),
        task.map(
            either.foldW(
                (e) => ({
                    // TODO better error handling?
                    notFound: true as const,
                }),
                (props) => ({
                    props,
                })
            )
        ),
        runTask
    );
};
export default (p: InferGetServerSidePropsType<typeof getServerSideProps>) => {
    const t = useTranslation(msg);
    return (
        <Layout subdomain={p.query.subdomain} seo={{ title: t.title }}>
            <Container maxWidth={"md"}>
                <Typography variant={"h4"} component={"h1"} gutterBottom>
                    {t.title}
                </Typography>
                {pipe(
                    p.seriesList,
                    nonEmptyArray.fromArray,
                    option.fold(constNull, (seriesList) => (
                        <ul>
                            {seriesList.map((series) => (
                                <li>
                                    <InternalLink
                                        href={seriesDetailRoute.route({
                                            subdomain: p.query.subdomain,
                                            seriesId: series.id,
                                        })}
                                    >
                                        <Link>{series.title}</Link>
                                    </InternalLink>
                                </li>
                            ))}
                        </ul>
                    ))
                )}
            </Container>
        </Layout>
    );
};

const msg = messages(
    {
        title: "Series",
    },
    {
        cs: {
            title: "Seriály",
        },
    }
);
